<div id="fachgebiete" class="page-wrapper">

	<app-menu [activeMenuIndex]="6">
	</app-menu>

	<!--<div class="subheader-bar-wrapper">
		<div class="subheader-content">
			<a href="https://www.lsd-diagnostik-partner.de/" target="_blank">
				<div class="subheader-content-text">
					Ihr kostenfreies Testset!
				</div>
			</a>
		</div>
	</div>-->

	<div class="title-wrapper">
    <div class="m-t-30 img-header">
      <img src="/assets/img/template/04-neurologie/neuro-header.png" />
    </div>
		<h1>
			Neurologie
		</h1>
		<div class="title-description">
      <ul class="bullet-neurologie">
        <li>Morbus Fabry kann Auswirkungen auf das periphere und das zentrale Nervensystem haben.<sup class="info-section-text-ref">1–10</sup></li>
        <li><a href="fachgebiete/neurologie#section-1" class="color-neurologie"><strong>Neuropathische Schmerzen</strong></a> sind häufig frühe Symptome.<sup class="info-section-text-ref">1</sup></li>
        <li><a href="fachgebiete/neurologie#section-2" class="color-neurologie"><strong>Zerebrovaskuläre Symptome</strong></a></li>
        <li>Im Erwachsenenalter: <a href="fachgebiete/neurologie#section-2" class="color-neurologie"><strong>Schlaganfall</strong></a>, TIA, Schwindel, Kopfschmerzen<sup class="info-section-text-ref">1</sup> - Häufigkeit: Männer 64 %, Frauen 72 %<sup class="info-section-text-ref">10</sup></li>
      </ul>
		</div>
	</div>

  <div class="info-section m-b-50">
    <div class="wrapper-half-title-center">
      <div class="separator m-t-0 neurologie"></div>
      <div class="info-section-title">
        Wann sollten Neurologen auf Morbus Fabry testen?
      </div>
    </div>
    <div class="wrapper-title-center">
      <ul class="bullet-neurologie text-center">
        <li>Bei <a href="fachgebiete/neurologie#section-3" class="color-neurologie"><strong>Schlaganfall</strong></a>/TIA im jungen Lebensalter (18–55 Jahre)<sup class="info-section-text-ref">3</sup></li>
        <li>Bei ungeklärten <a href="fachgebiete/neurologie#section-4" class="color-neurologie"><strong>neuropathischen Schmerzen</strong></a><sup class="info-section-text-ref">11</sup></li>
        <li>Bei Anzeichen weiterer <a href="morbus-fabry#section-3a" class="color-neurologie"><strong>Organbeteiligung</strong></a> (z.B. Herz, Niere, Auge, Gastrointestinaltrakt)<sup class="info-section-text-ref">11</sup></li>
        <li>Bei relevanter <a href="morbus-fabry#section-5" class="color-neurologie"><strong>Familienanamnese</strong></a><sup class="info-section-text-ref">11</sup></li>
        <li>Bei Verdacht auf Multiple Sklerose ohne Nachweis oligoklonaler Banden<sup class="info-section-text-ref">11</sup></li>
      </ul>
    </div>
  </div>

  <div class="info-section fullwidth info-ribbon with-video-float color-white bgcolor-neurologie">
    <div class="ribbon-left"><img src="/assets/img/template/04-neurologie/dreieck-1.png"></div>
    <div class="info-section-title">
			Wann sollte in der Neurologie an  Morbus Fabry gedacht werden?
		</div>
    <p class="text-center">
      Dies erläutert PD Dr. Tobias Böttcher, Greifswald, im Neurologie-Expertenvideo.
		</p>
    <div class="video-float">
      <iframe src="https://www.youtube.com/embed/e2ftoowxRtc"  class="neurologie" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
	</div>

  <div class="info-section m-b-20">
    <div class="wrapper-half-center">
      <div class="separator m-t-0 neurologie"></div>
      <div class="info-section-title m-b-40">
        Periphere neurologische
        Symptome: häufig schon im
        Kindes- und frühen
        Erwachsenenalter<sup class="info-section-text-ref">1,7</sup>
      </div>
    </div>
    <div class="wrapper-half-center">
      <div class="info-section-image m-b-0 text-center">
        <img src="/assets/img/template/04-neurologie/symptommann.png" />
      </div>
    </div>
  </div>

  <div class="info-section m-t-0">
    <div class="wrapper-half-title-center">
      <div class="separator neurologie"></div>
      <div class="info-section-title">
        <a id="section-0"></a>
        Typisch Morbus Fabry: Neuropathische Schmerzen
      </div>
    </div>
    <div class="wrapper-half-center m-t-30">
      <div class="cols-2 p-t-20">
        <div class="col">
          <div class="info-section-image m-b-0">
            <img src="/assets/img/template/04-neurologie/mann-icon.png" />
          </div>
          <p class="text-center"> 80 % der männlichen Patienten<sup class="info-section-text-ref">12</sup></p>
        </div>
        <div class="col">
          <div class="info-section-image m-b-0">
            <img src="/assets/img/template/04-neurologie/frau-icon.png" />
          </div>
          <p class="text-center">> 65 % der weiblichen Patienten<sup class="info-section-text-ref">12</sup></p>
        </div>
      </div>
      <p class="text-center">
        <a id="section-4"></a>
        Neuropathische Schmerzen zählen zu
        den häufigsten und frühsten
        Symptomen, die oft schon im
        <strong>Kindesalter</strong> vorkommen.
        Erstmanifestationen treten im Mittel bei
        <strong>Jungen</strong> im Alter von <strong>9 Jahren</strong> auf, bei
        <strong>Mädchen</strong> im Alter von <strong>16 Jahren.</strong><sup class="info-section-text-ref">12</sup>
      </p>
    </div>
  </div>

  <div class="info-section m-t-0">
    <div class="wrapper-half-title-center">
      <div class="separator neurologie"></div>
      <div class="info-section-title">
        Schmerzen haben einen
        signifikanten Einfluss auf
        die Lebensqualität<sup class="info-section-text-ref">14</sup>
      </div>
    </div>
    <div class="wrapper-half-center">
      <div class="info-section-image text-center">
        <img src="/assets/img/template/04-neurologie/hand-icon.png" style="margin-right: 10px" />
        <img src="/assets/img/template/04-neurologie/fuss-icon.png" style="margin-left: 10px" />
      </div>
      <a id="section-1"></a>
      <p class="text-center">
        Die Schmerzen beginnen in den Händen
        und Füßen und strahlen nach proximal
        aus.<sup class="info-section-text-ref">1,13</sup>
      </p>
      <p class="text-center">
        Patienten leiden unter brennenden und
        stechenden Schmerzen.<sup class="info-section-text-ref">1,15</sup>
      </p>
    </div>
  </div>

  <div class="info-section m-t-0">
    <div class="wrapper-half-title-center">
      <div class="separator neurologie"></div>
      <div class="info-section-title">
        Die meisten Schmerzen
        sind auf eine Small Fiber
        Neuropathie (SFN)
        zurückzuführen<sup class="info-section-text-ref">8,16</sup>
      </div>
    </div>
    <div class="wrapper-half-center m-t-20">
        <p class="text-center">
        Die SFN entsteht durch die
        <a href="morbus-fabry#section-2" class="color-neurologie"><strong>Akkumulation von Gb3</strong></a> in den
        Hinterwurzelganglienzellen, im
        Perineurium und in den Endothelzellen
        der Vasa nervorum.<sup class="info-section-text-ref">17</sup>
      </p>
      <p class="text-center">
        <strong>Frühe Symptome:</strong><br>
        Kälteempfindungsstörungen durch eine
        Schädigung der dünn<br> myelinisierten
        Aδ(m)-Fasern
      </p>
      <p class="text-center">
        <strong>Späte Symptome:</strong><br>
        Wärmeempfindungsstörungen durch
        eine Schädigung der<br> unmyelinisierten C-Fasern<sup class="info-section-text-ref">8,17</sup>
      </p>
      <div class="info-section-image text-center m-t-50 m-b-50">
        <img src="/assets/img/template/04-neurologie/blitz-icon.png" />
      </div>
      <p class="text-center">
        Schmerzen können getriggert
        werden durch<sup class="info-section-text-ref">8</sup>
      </p>
      <ul class="bullet-neurologie text-center">
        <li>Temperaturveränderungen</li>
        <li>Körperliche Belastung</li>
        <li>Stress</li>
        <li>Fieber</li>
      </ul>
    </div>
  </div>

  <div class="info-section">
    <div class="wrapper-center">
      <div class="cols-2">
        <div class="col">
          <div class="info-section-block margin-center">
            <div class="info-section-circle-center neurologie">
              <div>
                <div class="subtitle">
                  Patienten mit<br>
                </div>
                <div class="title">
                  <strong>vermeintlich<br>
                  idiopathischer SFN<br></strong>
                </div>
                <div class="subtitle">
                  <a href="https://www.lsd-diagnostik-partner.de/" class="color-white" target="_blank">sollten auf Morbus Fabry<br>
                  getestet werden.
                  </a>
                </div>
              </div>
            </div>
          <div class="info-section-circle-center-badge neurologie">
              <div>
                Wichtig!
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="info-section wrapper-center m-t-40 m-b-0">
    <div class="wrapper-half-center">
        <div class="info-section-image text-center m-b-40">
        <img src="/assets/img/template/04-neurologie/achtung-blau.png" />
      </div>
      <p class="text-center">
        Es kann aufgrund von starken
        neuropathischen Schmerzen zu
        sogenannten <strong>Fabry-Krisen</strong> kommen, die
        eine stationäre Behandlung notwendig
        machen. Unterstützung für eine
        <strong>systematische Schmerzanamnese</strong>
        finden Sie <a href="https://www.fabry-wissen.de/assets/downloads/infokarte_systematische_schmerzanalyse1.pdf" target="_blank" class="color-neurologie"><strong>hier</strong></a>.
      </p>
    </div>
  </div>

  <div class="info-section m-b-0">
    <div class="wrapper-half-center">
      <div class="separator neurologie"></div>
      <div class="info-section-title m-t-20">
        Schmerzen können
        den ganzen Körper
        betreffen<sup class="info-section-text-ref">13,19,20</sup>
      </div>
    </div>
    <div class="wrapper-half-center">
      <div class="info-section-subtitle3 color-neurologie text-center">Schmerzlokalisation bei 287 Morbus
        Fabry-Patienten<br>
        (148 Männer, 139 Frauen)<sup class="info-section-text-ref">13</sup>
      </div>
      <div class="info-section-image m-t-30 m-b-0 text-center">
        <img src="/assets/img/template/04-neurologie/schmerzlokalisation-chart.png" />
      </div>
      <div class="text-em margin-center text-center">
        Abb. modiziziert nach HOFFMANN, B. et al. 2007<sup class="info-section-text-ref">13</sup>
      </div>
    </div>
  </div>

  <div class="info-section">
    <div class="separator neurologie"></div>
    <div class="wrapper-half-title-center">
      <div class="info-section-title m-t-20">
        4 Schmerztypen, die bei Morbus Fabry auftreten
      </div>
    </div>
		<div class="info-section-half-squares margin-center">
			<div class="info-section-block bgcolor-neurologie">
				<div class="info-section-block-text">
          <p class="text-center">
            <strong>Evozierte Schmerzen<sup class="info-section-text-ref">19</sup></strong>
          </p>
          <p class="text-center">
            können sich als Allodynie (nicht-<br>schmerzhafte
            Reize werden als
            schmerzhaft wahrgenommen) oder
            Hyperalgesie (Schmerzreize werden als
            stärker schmerzhaft wahrgenommen)
            manifestieren.
          </p>
				</div>
			</div>
			<div class="info-section-block bgcolor-neurologie-inverted color-neurologie">
				<div class="info-section-block-text">
          <p class="text-center">
            <strong>Schmerzattacken<sup class="info-section-text-ref">19</sup></strong>
          </p>
          <p class="text-center">
            mit plötzlich einsetzenden
            brennenden, stechenden,
            kribbelnden oder einschießenden
            Schmerzen („Akroparästhesien“), in
            den distalen Extremitäten
            beginnend und nach proximal
            ausbreitend.
          </p>
				</div>
			</div>
			<div class="info-section-block bgcolor-neurologie-inverted only-md color-neurologie">
				<div class="info-section-block-text">
          <p class="text-center">
            <strong>Chronische Schmerzen<sup class="info-section-text-ref">19</sup></strong>
          </p>
          <ul class="text-center">
            <li>Von milder bis moderater
              Intensität, vor allem in den Händen
              und Füßen, die auch ohne
              identifizierbare Triggerfaktoren
              persistieren</li>
            <li>Können zur Entstehung von
              Stimmungsschwankungen,
              Verhaltensauffälligkeiten und
              Depression beitragen.</li>
          </ul>
				</div>
			</div>
			<div class="info-section-block bgcolor-neurologie only-md">
				<div class="info-section-block-text">
          <p class="text-center">
            <strong>Schmerzkrisen<sup class="info-section-text-ref">19</sup></strong>
          </p>
          <p class="text-center">
            sind akute Attacken mit quälenden,
            unerträglichen Schmerzen, die sich
            auf den gesamten Körper
            ausbreiten können und Minuten bis
            Tage anhalten. Sie können durch
            endogene oder exogene
            Einflussfaktoren getriggert werden
            und den Trigger überdauern.
          </p>
				</div>
			</div>
		</div>
	</div>

  <div class="info-section">
    <div class="wrapper-center">
      <div class="info-section-subtitle3 color-neurologie text-center">
        Prozentuale Häufigkeit der 4
        Schmerztypen und der betroffenen<br>
        Regionen<sup class="info-section-text-ref">3</sup>
      </div>
      <div class="info-section-image m-b-0 text-center">
        <img src="/assets/img/template/04-neurologie/hauefigkeit-chart.png" />
      </div>
      <div class="text-em margin-center text-center">
        Abb. modifiziert nach ÜÇEYLER, N. et al. 2014<sup class="info-section-text-ref">20</sup>
      </div>
    </div>
	</div>

  <div class="info-section m-b-0">
    <div class="wrapper-half-title-center">
      <div class="separator neurologie"></div>
      <div class="info-section-title m-b-0">
        Empfehlungen der <a href="https://dgn.org/leitlinien/ll-030-067-diagnostik-bei-polyneuropathien-2019" target="_blank" class="color-neurologie"><strong>DGN</strong></a> in
        der<br> S1-Leitlinie von 2019
        „Diagnostik bei<br>
        Polyneuropathien“ <sup class="info-section-text-ref">21</sup>
      </div>
    </div>
  </div>

  <div class="info-section p-t-0 p-b-40 fullwidth info-ribbon bgcolor-neurologie-inverted color-neurologie">
    <div class="ribbon-center"><img src="/assets/img/template/04-neurologie/dreieck-2.png"></div>
    <div class="wrapper-half-center">
      <p class="text-center">
        „Aufgrund der therapeutischen Relevanz
        (Enzymersatztherapie) sollte bei
        Patienten mit <strong>Polyneuropathien</strong> mit
        ausgeprägten <strong>neuropathischen</strong>
        <strong>Schmerzen</strong> auch an einen <strong>Morbus
        Fabry mit Mutationen im GLA-Gen</strong>
        gedacht werden.“
      </p>
    </div>
	</div>

  <div class="info-section">
    <div class="info-section-block">
			<div class="info-section-circle-center neurologie">
				<div>
          <a href="https://www.lsd-diagnostik-partner.de/" target="_blank" class="invisible-link">
            <div class="title">
              Bei unklarer<br>
              Polyneuropathie<br>
              mit ausgeprägten<br>
              <span style="font-weight: bold;">neuropathischen<br>
              <a id="section-2"></a>
              Schmerzen</span><br>
              <a href="https://www.lsd-diagnostik-partner.de/" class="color-white" target="_blank">an Morbus Fabry<br>
              denken und testen!<br></a>
            </div>
          </a>
      </div>
			</div>
    </div>
  </div>

  <div class="info-section m-b-20">
    <div class="wrapper-half-title-center">
      <div class="separator neurologie"></div>
      <div class="info-section-title">
        Zentrales Nervensystem:<br>
        Kryptogene Schlaganfälle,
        TIA und White<br> Matter
        Lesions<sup class="info-section-text-ref">4</sup>
      </div>
      <p class="text-center p-b-20">
        Im ZNS führt die <a href="morbus-fabry#section-2" class="color-neurologie"><strong>Ablagerung von Gb3</strong></a> in
        den zerebralen Gefäßen zu klinischen
        und neuroradiologischen
        Manifestationen. Ob die in einigen
        Hirnregionen nachweisbare Gb3-
        Ablagerung tatsächlich eine klinische
        Bedeutung hat, konnte bisher nicht
        gezeigt werden.
      </p>
      <div class="info-section-image m-t-50 m-b-0 text-center">
        <img src="/assets/img/template/04-neurologie/kopfschmerzen-icon.png" />
      </div>
      <p class="text-center m-t-0 p-b-20">
        Die Beteiligung der Gefäße des zentralen
        Nervensystems bei Morbus Fabry zeigt
        sich in einer erhöhten Inzidenz von
        Schlaganfällen und TIA schon im jungen
        Lebensalter.
      </p>
      <div class="info-section-image m-t-50 m-b-0 text-center">
        <img src="/assets/img/template/04-neurologie/achtung-blau.png" />
      </div>
      <a id="section-3"></a>
      <p class="text-center m-t-0 p-b-30">
        Eine Vielzahl von Patienten erleiden<br>
        ihren ersten Schlaganfall vor der<br>
        Diagnose des Morbus Fabry.
      </p>
    </div>
  </div>


  <div class="info-section m-b-40">
    <div class="wrapper-half-title-center">
      <div class="separator m-t-0 m-b-40 neurologie"></div>
      <div class="info-section-title">
        Juveniler Schlaganfall<br>
        (18–55 Jahre) – ein Indikator
        für<br> Morbus Fabry?<sup class="info-section-text-ref">4</sup>
      </div>
      <div class="info-section-subtitle3 color-neurologie text-center m-b-30">
        Medianes Alter beim Schlaganfall
      </div>

      <div class="cols-2 p-t-20">
        <div class="col">
          <div class="info-section-image text-center m-b-0">
            <img src="/assets/img/template/04-neurologie/mann-icon.png" />
          </div>
          <div class="color-blue"><strong>39 Jahre</strong></div>
        </div>
        <div class="col">
          <div class="info-section-image text-center m-b-0">
            <img src="/assets/img/template/04-neurologie/frau-icon.png" />
          </div>
          <div class="color-pink"><strong>46 Jahre</strong></div>
        </div>
      </div>
      <div class="wrapper-half-center">
        <p class="text-center">
          Das Risiko eines Schlaganfalls ist bei
          männlichen Fabry-Patienten zwischen
          dem 25. und 44. Lebensjahr um das
          <strong>12-Fache</strong> höher als bei einem
          Vergleichskollektiv aus der Allvgemeinbevölkerung.
        </p>
      </div>
    </div>
  </div>

  <div class="info-section m-b-0 fullwidth info-ribbon color-white bgcolor-neurologie">
    <div class="ribbon-left"><img src="/assets/img/template/04-neurologie/dreieck-1.png"></div>
    <div class="wrapper-center">
      <div class="info-section-subtitle2 text-center"><strong>Eine frühe Diagnose ist wichtig, damit
        rechtzeitig eine<br> angemessene
        Behandlung eingeleitet werden kann.</strong>
      </div>
    </div>
	</div>

  <div class="info-section m-t-20 m-b-20">
    <div class="wrapper-half-center">
      <p class="text-center">
        Schlaganfälle stellen eine ernste und
        häufige Komplikation des Morbus Fabry
        bei Männern und Frauen dar.<sup class="info-section-text-ref">1,4,22</sup>
        Schlaganfälle können eine wesentliche
        Ursache für einen frühen Tod bei Morbus
        Fabry-Patienten sein.<sup class="info-section-text-ref">5,22</sup>
      </p>
    </div>
    <div class="wrapper-half-title-center m-t-40">
      <div class="info-section-subtitle3 color-neurologie text-center m-t-30">
        Normalbevölkerung: Risiko für
        Schlaganfälle steigt deutlich ab
        55. Lebensjahr
      </div>
    </div>
    <div class="wrapper-half-center">
        <div class="info-section-image text-center m-b-0">
        <img src="/assets/img/template/04-neurologie/normalbevoelkerung-chart@2x.png" />
      </div>
      <div class="text-em margin-center text-center">
        Abb. modifiziert nach SIMS, K. et al. 2009<sup class="info-section-text-ref">4</sup>
      </div>
    </div>
  </div>

  <a id="section-gibt-es-klare"></a>
  <div class="info-section m-b-0">
    <div class="wrapper-half-center">
      <div class="separator neurologie"></div>
      <div class="info-section-title m-b-40">
        Gibt es klare
        neuroradiologische
        Manifestationen?
      </div>
    </div>
    <div class="wrapper-center">
      <div class="info-section-image text-center m-b-30">
        <img src="/assets/img/template/04-neurologie/manifestationen-icon.png" />
      </div>
    </div>
    <div class="wrapper-half-center">
      <ul class="bullet-neurologie text-center">
        <li>Zeichen früherer zerebraler Ischämien
          (Hirninfarkte, mikroangiopathisch-lakunär
          oder embolisch-territorial) oder
          Hirnblutungen</li>
        <li>White Matter Lesions (WML)<sup class="info-section-text-ref">23</sup></li>
        <li>Erweiterte und vermehrt geschlängelte
          arterielle Blutgefäße (Ektasie und
          Tortuositas vasorum), vor allem
          vertebrobasilär</li>
        <li>Pulvinar-Zeichen<sup class="info-section-text-ref">8</sup></li>
        <li>Hippocampus-Atrophie<sup class="info-section-text-ref">24,25</sup></li>
      </ul>
    </div>
  </div>

  <div class="info-section">
    <div class="wrapper-center">
      <div class="separator neurologie"></div>
      <div class="info-section-title">
        MRT-Auffälligkeiten bei
        Morbus Fabry
      </div>
      <div class="info-section-subtitle3 color-neurologie text-center m-t-40 m-b-10">
        MRT, T1
      </div>
      <div class="info-section-image text-center m-b-0">
        <img src="/assets/img/template/04-neurologie/mrt-t1.png" />
      </div>
      <p class="text-center">
        Bilaterale Signalerhöhung im posterioren<br>
        Thalamus („Pulvinar-Zeichen“)
      </p>
      <div class="info-section-subtitle3 color-neurologie text-center m-t-30 m-b-10">
        MRT TOF
      </div>
      <div class="info-section-image text-center m-b-0">
        <img src="/assets/img/template/04-neurologie/mrt-tof.png" />
      </div>
      <p class="text-center">
        <span class="color-neurologie"><strong>1 </strong></span>Erweiterte A. basilaris<br>
        <span class="color-neurologie"><strong>2 </strong></span>A. cerebri anterior<br>
        <span class="color-neurologie"><strong>3 </strong></span>A. carotis interna
      </p>
      <p class="text-center">
        Geschlängelte und dilatierte Blutgefäße
      </p>
      <div class="info-section-subtitle3 color-neurologie text-center m-t-30 m-b-10">
        MRT, FLAIR
      </div>
      <div class="info-section-image text-center m-b-0">
        <img src="/assets/img/template/04-neurologie/mrt-flair.png" />
      </div>
      <p class="text-center">
        <span class="color-neurologie"><strong>1 </strong></span>Hirninfarkt A. cerebri media rechts<br>
        <span class="color-neurologie"><strong>2 </strong></span>WML linke Hemisphäre<br>
      </p>
      <div class="text-em margin-center text-center">
        Abbildungen mit freundlicher Genehmigung von Prof. Dr. Arndt Rolfs,
          Universität Rostock.
      </div>
    </div>
  </div>

  <div class="info-section">
    <div class="wrapper-half-title-center">
      <div class="separator m-t-0 neurologie"></div>
      <div class="info-section-title">
        WML: Charakteristische
        Komplikationen des Morbus
        Fabry<sup class="info-section-text-ref">10,24</sup>
      </div>
    </div>
    <div class="wrapper-half-center">
      <ul class="bullet-neurologie text-center">
        <li>WML sind klinisch relevant und neben
          Morbus Fabry assoziiert mit:
          Schlaganfall, Epilepsie, Depression und
          kognitivem Abbau.<sup class="info-section-text-ref">26</sup></li>
        <li>Häufig bei Älteren und bei Patienten
          mit klassischen vaskulären
          Risikofaktoren, wie z. B. arteriellem
          Hypertonus<sup class="info-section-text-ref">27</sup></li>
      </ul>
    </div>
  </div>

  <div class="info-section m-b-50">
    <div class="wrapper-center">
      <div class="cols-2">
        <div class="col">
          <div class="info-section-block margin-center">
            <div class="info-section-circle-center neurologie">
              <div>
                <div class="title">
                  Es gibt für Morbus Fabry<br>
                  <span style="font-weight: bold;">keine absolut
                  spezifischen<br>
                  neuroradiologischen<br>
                  Befunde!</span>
                </div>
              </div>
            </div>
            <div class="info-section-circle-center-badge neurologie">
              <div class="info-section-image m-b-0 text-center">
                <img src="/assets/img/template/04-neurologie/achtung-blau.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="info-section m-b-20">
    <div class="wrapper-half-center">
      <div class="separator neurologie"></div>
      <div class="info-section-title">
        Multiple Sklerose oder
        Morbus Fabry?
      </div>
      <div class="info-section-subtitle3 m-b-10 color-neurologie text-center">
        MRT, T2 sagittal eines Morbus
        Fabry-Patienten mit<br> initialer
        Fehldiagnose MS
      </div>
    </div>
    <div class="wrapper-center">
      <div class="info-section-image m-b-0 text-center">
        <img src="/assets/img/template/04-neurologie/mrt-t2-sagittal.png" />
      </div>
    </div>
    <div class="wrapper-half-center">
      <div class="text-em margin-center text-center">
        Abbildung mit freundlicher Genehmigung von Prof. Dr. Arndt Rolfs,
        Universität Rostock.
      </div>
      <ul class="bullet-neurologie text-center m-t-30 m-b-30">
        <li>Eine häufige Fehldiagnose ist die
          Multiple Sklerose, die ebenfalls
          Hirnläsionen verursacht und deren
          neurologische Symptomatik (zerebrale
          Ischämie vs. MS-Schub) häufig ähnlich
          ist.</li>
        <li>Eine sichere bildmorphologische
          Unterscheidung zwischen WML bei
          Morbus Fabry und demyelinisierenden
          MS-Herden ist nicht möglich.</li>
        <li>Leichte entzündliche
          Liquorveränderungen sind auch bei
          Morbus Fabry beschrieben.</li>
      </ul>
    </div>
  </div>

  <div class="info-section">
    <div class="info-section-block">
			<div class="info-section-circle-center neurologie-inverted">
				<div>
          <div class="info-section-title" style="font-size: 30px;">
					  Bei Morbus Fabry-<br>
            Patienten liegen<br> keine
            oligoklonalen<br> Banden
            vor!

          </div>
				</div>
			</div>
    </div>
  </div>

  <div class="info-section p-b-50 fullwidth info-ribbon color-white bgcolor-neurologie">
    <div class="ribbon-left"><img src="/assets/img/template/04-neurologie/dreieck-1.png"></div>
    <div class="ribbon-right"><img src="/assets/img/template/04-neurologie/dreieck-2.png"></div>
    <div class="wrapper-half-center">
      <div class="info-section-subtitle3 color-white text-center">
        Patienten mit v. a. Multipler Sklerose,
        aber untypischem MRT-Befund und
        fehlendem Nachweis oligoklonaler
        Banden sollten auf Morbus Fabry
        <strong><a href="https://www.lsd-diagnostik-partner.de/" class="color-white" target="_blank"><strong>getestet werden.</strong></a></strong>
    </div>
    </div>
	</div>

  <div class="info-section">
    <div class="wrapper-half-center">
      <div class="separator neurologie"></div>
      <div class="info-section-title">
        Die Abgrenzung von Morbus
        Fabry zu Multipler Sklerose
        ist komplex<sup class="info-section-text-ref">11,28,29</sup>
      </div>
    </div>
    <div class="wrapper-half-center">
      <div class="info-section-image text-center m-b-0">
        <img src="/assets/img/template/04-neurologie/Neuro_Folder_Grafik.jpg" />
      </div>
      <div class="text-em margin-center text-center">
        * Sensitivität: 95–100 %; ** Sensitivität: 90 %.
      </div>
    </div>
    <div class="wrapper-center">
      <div class="info-section-subtitle3 color-neurologie text-center m-t-40">Fehldiagnosen bei Morbus Fabry: ein breites Spektrum</div>
      <div class="info-section-image text-center m-b-0">
        <img src="/assets/img/template/04-neurologie/fehldiagnosen-chart.png" />
      </div>
      <div class="text-em margin-center text-center">
        Abb. modifiziert nach MEHTA, A. et al. 2004<sup class="info-section-text-ref">3</sup>
      </div>
      <ul class="bullet-neurologie m-t-30 text-center">
        <li>Der klinische Verlauf von Morbus Fabry
          kann stark variieren.</li>
        <li>Es besteht ein breites Spektrum
          möglicher Differentialdiagnosen.</li>
      </ul>
    </div>
  </div>

  <div class="info-section p-b-40 p-t-10 fullwidth info-ribbon color-neurologie bgcolor-neurologie-inverted">
    <div class="ribbon-center"><img src="/assets/img/template/04-neurologie/dreieck-2.png"></div>
    <div class="wrapper-half-title-center">
      <div class="info-section-subtitle3 color-neurologie text-center m-t-40 m-b-30">
        Bei unklaren Pathologien oder
        atypischen Verläufen sollte Morbus
        Fabry als Differentialdiagnosen
        Erwägung gezogen werden.<sup class="info-section-text-ref">30</sup>
      </div>
    </div>
	</div>
</div>

<div class="m-b-50"></div>

<app-footer>
</app-footer>


<style>
	/*.info-section-container {
		display: flex;
		flex-wrap: wrap;
		width: 1200px;
		margin-bottom: 120px;
	}
	@media only screen and (max-width: 768px) {
		.info-section-container {
			width: calc(100% + 64px);
			margin-bottom: 8px;
		}
	}*/
</style>
